export const STREET_ADDRESS_ONE = 'street_address';
export const STREET_ADDRESS_TWO = 'unit_number';
export const ZIP_CODE = 'zip_code';
